<div class="file-drop-zone" appFileDrop (filesDropped)="onFilesDropped($event)" (filesHovered)="onFilesHovered($event)">
  <div class="file-drop-content">
    <p i18n>Arrastra tus archivos aquí</p>
    <p i18n>o</p>
    <input type="file" (change)="onFileInputChange($event)" [accept]="accept" multiple>
  </div>
</div>
